/**
 * A global namespace for `focus` event.
 */
const focusEvent = "focus";
export default focusEvent;
